import { EMOTIONS, MOOD_LEVELS, TRIGGERS } from '@shared/constants';
import type { IMoodRecordDraft, IMoodRecordDraftComplete, MoodLevel } from '@shared/types';

type ValidatedMoodRecordDraft = IMoodRecordDraft & { mood: MoodLevel };

export function validateMoodRecordDraft(
  draft: IMoodRecordDraft | null
): asserts draft is ValidatedMoodRecordDraft {
  if (!draft || !draft.mood) {
    throw new Error('Invalid mood record draft (validateMoodRecordDraft).');
  }
}

export function validateMoodRecordDraftComplete(
  draft: IMoodRecordDraft | null
): asserts draft is IMoodRecordDraftComplete {
  if (
    !draft?.id ||
    !draft.mood ||
    !draft.moodDate ||
    !draft.ownerId ||
    !Object.values(MOOD_LEVELS).includes(draft.mood) ||
    !Array.isArray(draft.emotions) ||
    !Array.isArray(draft.sharedWithFriends) ||
    !Array.isArray(draft.triggers) ||
    draft.emotions.some((emotion) => !EMOTIONS[emotion]) ||
    draft.triggers.some((trigger) => !TRIGGERS[trigger])
  ) {
    if (process.env.NODE_ENV === 'development') {
      console.error(buildDevErrorMessage(draft));
    }
    throw new Error('Invalid mood record draft complete (validateMoodRecordDraftComplete).');
  }
}

function buildDevErrorMessage(draft: IMoodRecordDraft | null): string {
  let errorMessage = 'Invalid mood record draft complete (buildDevErrorMessage).';
  if (!draft?.id) {
    errorMessage += ' Missing id.';
  }
  if (!draft?.mood) {
    errorMessage += ' Missing mood.';
  }
  if (!Object.values(MOOD_LEVELS).includes(draft?.mood as MoodLevel)) {
    errorMessage += ' Invalid mood.';
  }
  if (!Array.isArray(draft?.emotions)) {
    errorMessage += ' Missing emotions.';
  }
  if (!Array.isArray(draft?.sharedWithFriends)) {
    errorMessage += ' Missing sharedWithFriends.';
  }
  if (!Array.isArray(draft?.triggers)) {
    errorMessage += ' Missing triggers.';
  }
  if (draft?.emotions?.some((emotion) => !EMOTIONS[emotion])) {
    errorMessage += ' Invalid emotions.';
  }
  if (draft?.triggers?.some((trigger) => !TRIGGERS[trigger])) {
    errorMessage += ' Invalid triggers.';
  }

  return errorMessage;
}
